import type { IconProps } from '../types.js'

export type BlockIconProps = Omit<IconProps, 'name'>

const BlockIcon = ({ className, size = 24 }: BlockIconProps) => {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M20.9999 8.34406C21.0033 8.09432 20.8823 7.84296 20.636 7.69851L13.1419 3.3036C12.4534 2.89983 11.6007 2.89873 10.9111 3.30073L3.36936 7.69754C3.12194 7.84178 3.0004 8.09373 3.00383 8.34406H2.99998V15.7741H3.00408C3.01084 16.0181 3.13643 16.2591 3.38002 16.3958L10.9431 20.638C11.6164 21.0156 12.4378 21.0146 13.11 20.6353L20.6254 16.3949C20.8679 16.258 20.9929 16.0175 20.9997 15.7741L20.9999 8.34406ZM4.76446 8.90766C4.58408 8.80589 4.35536 8.86961 4.25359 9.04998C4.15181 9.23036 4.21553 9.45909 4.39591 9.56086L10.7548 13.1487C11.5471 13.5957 12.516 13.5934 13.3061 13.1425L19.5841 9.55996C19.764 9.45731 19.8266 9.22828 19.7239 9.0484C19.6213 8.86852 19.3922 8.80591 19.2123 8.90856L12.9343 12.4911C12.3735 12.8112 11.6858 12.8128 11.1234 12.4955L4.76446 8.90766Z"
      />
    </svg>
  )
}

export default BlockIcon
